function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { Time, Calendar } from '@carbon/react/icons';
import autoBind from 'react-autobind';
import { Button, Link, ClickableTile } from '@carbon/react';
import { Card, CardHeader, CardBody, PageHeader } from '@console/cloud-pal-community/components/Basic';
import { GridLayout } from '@console/cloud-pal-community/components/Layout';
import config from '../../lib/shared/config';
import hrefs from '../../lib/shared/hrefs';
import Msg from '../common/msg.jsx';
import msgs from '../../nls/welcome/welcome.properties';
import React from 'react';
import staticResources from '../../lib/shared/static-resources';
import { AppContext } from '../common/app-context.js';
import '../../scss/welcome/_welcome-content.scss';
var WelcomeContent = /*#__PURE__*/function (_React$Component) {
  function WelcomeContent(props) {
    var _this;
    _classCallCheck(this, WelcomeContent);
    _this = _callSuper(this, WelcomeContent, [props]);
    _this.state = {};
    autoBind(_this);
    return _this;
  }
  _inherits(WelcomeContent, _React$Component);
  return _createClass(WelcomeContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var envId = this.context.envId,
        locale = this.context.locale;
      return /*#__PURE__*/React.createElement("div", {
        id: "main-content",
        className: "welcome-content ".concat(this.props.className)
      }, /*#__PURE__*/React.createElement("section", _extends({
        className: "hero"
      }, this.state.mounted && {
        style: {
          backgroundImage: 'url("' + staticResources.href('graphics/getting-started-hero-image.png', this.context.cdnDomain) + '")'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "hero-content"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        title: msgs.get('hero.heading', locale)
      }), /*#__PURE__*/React.createElement("p", null, msgs.get('hero.subheading', locale)))), /*#__PURE__*/React.createElement("section", {
        className: "use-cases"
      }, /*#__PURE__*/React.createElement("h2", null, msgs.get('use-case.section.title', locale)), /*#__PURE__*/React.createElement(GridLayout.Row, {
        hasEqualCols: true
      }, function () {
        var useCases = [{
          entry: 'use-case1',
          heading: msgs.get('section.use-case1.heading', locale),
          iconAlt: 'delivery-pipeline-icon',
          iconSrc: staticResources.href('graphics/delivery-pipeline.svg', _this2.context.cdnDomain),
          body: msgs.get('section.use-case1.body', locale)
        }, {
          entry: 'use-case2',
          heading: msgs.get('section.use-case2.heading', locale),
          iconAlt: 'kubernetes-icon',
          iconSrc: staticResources.href('graphics/kubernetes-logo.svg', _this2.context.cdnDomain),
          body: msgs.get('section.use-case2.body', locale)
        }, {
          entry: 'use-case3',
          heading: msgs.get('section.use-case3.heading', locale),
          iconAlt: 'infrastructure-as-code-icon',
          iconSrc: staticResources.href('graphics/infrastructure-as-code.svg', _this2.context.cdnDomain),
          body: msgs.get('section.use-case3.body', locale)
        }, {
          entry: 'use-case4',
          heading: msgs.get('section.use-case4.heading', locale),
          iconAlt: 'continuous-delivery-icon',
          iconSrc: staticResources.href('graphics/continuous-delivery.svg', _this2.context.cdnDomain),
          body: msgs.get('section.use-case4.body', locale)
        }];
        return useCases.map(function (useCase) {
          return /*#__PURE__*/React.createElement(Card, {
            className: "use-case",
            key: useCase.entry
          }, /*#__PURE__*/React.createElement("div", {
            className: "cpc--card__header card-title"
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            className: "cpc--card__title"
          }, /*#__PURE__*/React.createElement("div", {
            className: "icon-container"
          }, /*#__PURE__*/React.createElement("img", {
            src: useCase.iconSrc,
            alt: useCase.iconAlt,
            title: useCase.iconAlt
          })), useCase.heading))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
            className: "use-case-body"
          }, /*#__PURE__*/React.createElement("p", {
            className: "text-section"
          }, useCase.body))));
        });
      }())), /*#__PURE__*/React.createElement("section", {
        className: "additional-content explore"
      }, /*#__PURE__*/React.createElement("h2", null, msgs.get('explore.section.title', locale)), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cards"
      }, /*#__PURE__*/React.createElement("div", {
        className: "two-col-layout"
      }, function () {
        var offerings = ['toolchains', 'delivery-pipeline', 'gitlab', 'deployment-risk', 'templates'];
        return offerings.map(function (offering) {
          return /*#__PURE__*/React.createElement(Card, {
            className: "offering",
            key: offering
          }, /*#__PURE__*/React.createElement("div", {
            className: "offering-icon"
          }, /*#__PURE__*/React.createElement("img", {
            src: staticResources.href("graphics/".concat(offering, ".svg"), _this2.context.cdnDomain),
            alt: ""
          })), /*#__PURE__*/React.createElement(CardHeader, {
            className: "card-title",
            title: msgs.get("section.offering.".concat(offering, ".heading"), locale),
            linkElement: null
          }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
            className: "offering-body"
          }, /*#__PURE__*/React.createElement("p", {
            className: "text-section"
          }, msgs.get('section.offering.' + offering + '.content', locale)))));
        });
      }())))), /*#__PURE__*/React.createElement("section", {
        className: "additional-content tutorials"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section-with-top-border"
      }, /*#__PURE__*/React.createElement("h2", null, msgs.get('tutorials.section.title', locale)), /*#__PURE__*/React.createElement("div", {
        className: "tutorial-tiles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fake-margins"
      }, /*#__PURE__*/React.createElement(ClickableTile, {
        href: "https://cloud.ibm.com/docs/ContinuousDelivery?topic=ContinuousDelivery-tutorial-cd-kubernetes",
        className: "tutorial-tile",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tutorial-desc-and-name",
        title: msgs.get('tutorials.first.description', locale)
      }, /*#__PURE__*/React.createElement("h3", {
        className: "tutorial-name"
      }, msgs.get('tutorials.first.title', locale)), /*#__PURE__*/React.createElement("p", {
        className: "tutorials-first-description"
      }, msgs.get('tutorials.first.description', locale))), /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-time"
      }, /*#__PURE__*/React.createElement(Time, null), "30 minutes"), /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-date"
      }, /*#__PURE__*/React.createElement(Calendar, null), new Date(2022, 10 - 1, 27).toLocaleDateString())))), /*#__PURE__*/React.createElement("div", {
        className: "fake-margins"
      }, /*#__PURE__*/React.createElement(ClickableTile, {
        href: "https://cloud.ibm.com/docs/devsecops?topic=devsecops-tutorial-cd-devsecops",
        className: "tutorial-tile",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tutorial-desc-and-name",
        title: msgs.get('tutorials.second.description', locale)
      }, /*#__PURE__*/React.createElement("h3", {
        className: "tutorial-name"
      }, msgs.get('tutorials.second.title', locale)), /*#__PURE__*/React.createElement("p", {
        className: "tutorials-second-description"
      }, msgs.get('tutorials.second.description', locale))), /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-time"
      }, /*#__PURE__*/React.createElement(Time, null), "1 hour"), /*#__PURE__*/React.createElement("div", {
        className: "tutorial-card-date"
      }, /*#__PURE__*/React.createElement(Calendar, null), new Date(2022, 7 - 1, 14).toLocaleDateString()))))))), /*#__PURE__*/React.createElement("section", {
        className: "additional-content join-community"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section-with-top-border"
      }, /*#__PURE__*/React.createElement("h2", null, msgs.get('join-community.section.title', locale)), /*#__PURE__*/React.createElement("div", {
        className: "community-parts"
      }, /*#__PURE__*/React.createElement("div", {
        className: "slack-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "slack-intro"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "slack-brand"
      }, /*#__PURE__*/React.createElement("img", {
        className: "slack-icon",
        src: staticResources.href('graphics/slack.svg', this.context.cdnDomain),
        alt: "slack-icon",
        title: "slack-icon"
      }), "slack"), /*#__PURE__*/React.createElement("h2", {
        className: "slack-title"
      }, msgs.get('join-community.section.slack-title', locale)), /*#__PURE__*/React.createElement("p", {
        className: "slack-description"
      }, msgs.get('join-community.section.slack-desc', locale)), /*#__PURE__*/React.createElement("div", {
        className: "slack-buttons"
      }, /*#__PURE__*/React.createElement(Button, {
        kind: "primary",
        href: config.CHAT_URL,
        target: "_blank",
        rel: "noopener noreferrer"
      }, msgs.get('join-community.section.slack-join', locale)), /*#__PURE__*/React.createElement(Button, {
        kind: "ghost",
        href: "https://ibm-devops-services.slack.com/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, msgs.get('join-community.section.slack-sign-in', locale)))), /*#__PURE__*/React.createElement("img", {
        className: "slack-graphic",
        src: staticResources.href('graphics/slack-skeleton.svg', this.context.cdnDomain),
        alt: "slack-graphic",
        title: "slack-graphic"
      }))))), /*#__PURE__*/React.createElement("section", {
        className: "additional-content learn-more"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section-with-top-border"
      }, /*#__PURE__*/React.createElement("h2", null, msgs.get('learn-more.section.title', locale)), /*#__PURE__*/React.createElement("div", {
        className: "documentation-text"
      }, /*#__PURE__*/React.createElement("img", {
        className: "docs-icon",
        src: staticResources.href('graphics/docs.svg', this.context.cdnDomain),
        alt: "docs-icon",
        title: "docs-icon"
      }), /*#__PURE__*/React.createElement(Msg, {
        className: "text-section",
        bundleKey: "learn-more.section.text",
        args: {
          '{0-1}': /*#__PURE__*/React.createElement(Link, {
            href: hrefs.docUrl('/docs/ContinuousDelivery?topic=ContinuousDelivery-getting-started'),
            target: "_blank",
            rel: "noopener noreferrer"
          }, "$text")
        },
        bundle: msgs
      })))));
    }
  }]);
}(React.Component);
export { WelcomeContent as default };
WelcomeContent.contextType = AppContext;